import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", {
  state: () => ({
    loading: false,
    // Contador de peticiones concurrentes: evita apagar el loader global si
    // una petición termina mientras otra sigue en curso.
    activeRequests: 0,
    ip: "",
  }),
  actions: {
    setLoading(loading) {
      this.loading = loading;
    },
    setIp(ip) {
      this.ip = ip;
    },
    startLoading() {
      this.activeRequests++;
      this.loading = true;
    },
    stopLoading() {
      this.activeRequests--;
      if (this.activeRequests <= 0) {
        this.activeRequests = 0;
        this.loading = false;
      }
    },
  },
});
